<div class="form-group">
    <label>{{ 'estudiar.plan_de_clases.sel_curso_title' | t }}:</label>
    <select class="form-control" [ngModel]="cursoSeleccionado" (ngModelChange)="cursoChanged($event)">
        <option [ngValue]="undefined">-- {{ 'estudiar.plan_de_clases.sel_curso' | t }} --</option>
        <option *ngFor="let curso of cursos; let i = index" [ngValue]="i">
            {{ curso.nombre }}
        </option>
    </select>
</div>
